var _linearGradient, _path, _path2, _path3, _path4, _linearGradient2, _path5, _linearGradient3, _circle, _path6, _circle2, _path7, _path8, _circle3, _circle4, _circle5, _circle6, _linearGradient4, _path9, _path10, _linearGradient5, _circle7, _linearGradient6, _circle8, _linearGradient7, _circle9, _linearGradient8, _circle10, _path11, _path12, _path13, _path14, _path15, _path16, _linearGradient9, _path17, _linearGradient10, _path18, _linearGradient11, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketAnalysis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "market-analysis_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 253.477,
    y1: 1076.485,
    x2: 259.474,
    y2: 568.682,
    gradientTransform: "translate(0 -566)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M367.6 47.6c-68.8-27.8-164.5-18.6-217.9 29-37.7 33.6-8.9 43.7 15.8 106.3C183.4 228.3.9 220 0 301.6c-1.1 94.3 131.3 77.9 180.3 89.2 74.8 17.4 139.5 79.8 219.8 72.6 69.8-6.3 97.1-60.7 107.5-123.4 19.3-116.7-23.6-245.3-140-292.4z",
    opacity: 0.25,
    fill: "url(#market-analysis_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M441.7 431.2l-74-74c-3.9-3.9-10.2-3.9-14.1 0l-4.1 4.1-34.2-34.2c49.8-62.5 45.8-153.7-12.1-211.6-62.2-62.1-163-62.1-225.2.1-55.6 55.6-61.5 142.1-17.6 204.2-3.7 6.5-5.8 14.1-5.8 22.1 0 25 20.3 45.3 45.3 45.3 11.7 0 22.4-4.5 30.5-11.8 52.2 21.2 113.4 13.6 159.1-22.8l34.2 34.2-4.1 4.1c-3.9 3.9-3.9 10.2 0 14.1l74 74c3.9 3.9 10.2 3.9 14.1 0l33.9-33.9c4-3.7 4-10 .1-13.9z",
    opacity: 0.11,
    fill: "#2626bc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M296.4 320.7l25.6-25.6 53.2 53.2-25.6 25.6-53.2-53.2z",
    fill: "#d2deff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M322.1 295.1l19.6 19.6c-3.8 4.7-7.8 9.2-12.1 13.5s-8.8 8.4-13.5 12.1l-19.6-19.6 25.6-25.6z",
    fill: "#b7c5ff"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "market-analysis_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 273.273,
    y1: 116.8,
    x2: 571.955,
    y2: 116.8,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#53acd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ae07d"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M459.7 424.3l-33.9 33.9c-3.9 3.9-10.2 3.9-14.1 0l-74-74c-3.9-3.9-3.9-10.2 0-14.1l33.9-33.9c3.9-3.9 10.2-3.9 14.1 0l74 74c3.9 3.9 3.9 10.2 0 14.1z",
    fill: "url(#market-analysis_svg__b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "market-analysis_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 22.576,
    y1: 207.1,
    x2: 420.937,
    y2: 207.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 208.6,
    cy: 207.1,
    r: 159.2,
    fill: "url(#market-analysis_svg__c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M348 130.2c-6.4 24.5-27.8 43.2-53.7 45.4-14.5 1.2-28-2.6-39-9.9l-19.5 8.6c-4 1.8-8.1-2.3-6.3-6.3l8.6-19.5c-7.3-11-11.1-24.5-9.9-39 1.9-23 17-42.5 37.4-51 20.3 7.7 39.2 19.8 55.6 36.1 10.7 10.8 19.7 22.8 26.8 35.6z",
    fill: "#4369fd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.6,
    cy: 207.1,
    r: 120.3,
    fill: "#bddaf2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M321.8 166.2c-8.1 5.2-17.5 8.6-27.5 9.4-14.5 1.2-28-2.6-39-9.9l-19.5 8.6c-4 1.8-8.1-2.3-6.3-6.3l8.6-19.5c-7.3-11-11.1-24.5-9.9-39 .6-7.1 2.5-13.9 5.3-20.1 22.1 4.6 43.1 15.5 60.2 32.7 12.9 12.9 22.3 28 28.1 44.1z",
    fill: "#94b5dd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M349.8 99.9c2.4-36.9-28-67.3-64.9-64.9-29.8 1.9-54.2 25.8-56.8 55.6-1.2 14.5 2.6 28 9.9 39l-8.6 19.5c-1.8 4 2.3 8.1 6.3 6.3l19.5-8.6c11 7.3 24.5 11.1 39 9.9 29.8-2.6 53.7-27 55.6-56.8z",
    fill: "#ffaf10"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.6,
    cy: 95.1,
    r: 6.9,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 95.1,
    r: 6.9,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 314.4,
    cy: 95.1,
    r: 6.9,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 321,
    r: 45.3,
    fill: "#ffaf10"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "market-analysis_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 73.097,
    y1: 277.45,
    x2: 336.183,
    y2: 277.45,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#53acd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ae07d"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.7 258.3h118c3.3 0 6-2.7 6-6v-31.5c0-3.3-2.7-6-6-6h-118c-3.3 0-6 2.7-6 6v31.5c0 3.3 2.7 6 6 6z",
    fill: "url(#market-analysis_svg__d)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M188.9 241.4h-51.8c-2.8 0-5-2.2-5-5s2.2-5 5-5h51.8c2.8 0 5 2.2 5 5s-2.2 5-5 5zm24.7 16.9h-76.5c-2.8 0-5-2.2-5-5s2.2-5 5-5h76.5c2.8 0 5 2.2 5 5s-2.2 5-5 5z",
    fill: "#fff"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "market-analysis_svg__e",
    gradientUnits: "userSpaceOnUse",
    x1: 197.762,
    y1: 335,
    x2: 208.938,
    y2: 335,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.4,
    cy: 179,
    r: 5.6,
    fill: "url(#market-analysis_svg__e)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "market-analysis_svg__f",
    gradientUnits: "userSpaceOnUse",
    x1: 214.666,
    y1: 335,
    x2: 225.842,
    y2: 335,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.3,
    cy: 179,
    r: 5.6,
    fill: "url(#market-analysis_svg__f)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "market-analysis_svg__g",
    gradientUnits: "userSpaceOnUse",
    x1: 197.762,
    y1: 317.8,
    x2: 208.938,
    y2: 317.8,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.4,
    cy: 196.2,
    r: 5.6,
    fill: "url(#market-analysis_svg__g)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "market-analysis_svg__h",
    gradientUnits: "userSpaceOnUse",
    x1: 214.666,
    y1: 317.8,
    x2: 225.842,
    y2: 317.8,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.3,
    cy: 196.2,
    r: 5.6,
    fill: "url(#market-analysis_svg__h)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7 103.4c-3.9 0-7.6-1.5-10.3-4.3-2.8-2.8-4.3-6.4-4.3-10.3s1.5-7.6 4.3-10.3c5.7-5.7 15-5.7 20.6 0 5.7 5.7 5.7 15 0 20.6-2.8 2.8-6.4 4.3-10.3 4.3zm0-19.2c-1.2 0-2.4.4-3.3 1.3-.9.9-1.3 2-1.3 3.3s.5 2.4 1.3 3.3c.9.9 2 1.3 3.3 1.3s2.4-.5 3.3-1.3c1.8-1.8 1.8-4.7 0-6.5-1-.9-2.2-1.4-3.3-1.4z",
    fill: "#8399fe"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M385.1 128.3c-3.9 0-7.6-1.5-10.3-4.3-5.7-5.7-5.7-15 0-20.6 2.8-2.8 6.4-4.3 10.3-4.3s7.6 1.5 10.3 4.3c5.7 5.7 5.7 15 0 20.6-2.7 2.8-6.4 4.3-10.3 4.3zm0-19.2c-1.2 0-2.4.5-3.3 1.3-1.8 1.8-1.8 4.7 0 6.5.9.9 2 1.3 3.3 1.3s2.4-.5 3.3-1.3c1.8-1.8 1.8-4.7 0-6.5-.9-.8-2.1-1.3-3.3-1.3z",
    fill: "#01eca5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91 48.7h-3.2v-3.2c0-2.8-2.2-5-5-5s-5 2.2-5 5v3.2h-3.2c-2.8 0-5 2.2-5 5s2.2 5 5 5h3.2v3.2c0 2.8 2.2 5 5 5s5-2.2 5-5v-3.2H91c2.8 0 5-2.2 5-5s-2.2-5-5-5zm309.8 244.9h-3.2v-3.2c0-2.8-2.2-5-5-5s-5 2.2-5 5v3.2h-3.2c-2.8 0-5 2.2-5 5s2.2 5 5 5h3.2v3.2c0 2.8 2.2 5 5 5s5-2.2 5-5v-3.2h3.2c2.8 0 5-2.2 5-5s-2.3-5-5-5z",
    fill: "#ff7eb8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M155.6 403.5h-3.2v-3.2c0-2.8-2.2-5-5-5s-5 2.2-5 5v3.2h-3.2c-2.8 0-5 2.2-5 5s2.2 5 5 5h3.2v3.2c0 2.8 2.2 5 5 5s5-2.2 5-5v-3.2h3.2c2.8 0 5-2.2 5-5s-2.2-5-5-5z",
    fill: "#01eca5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M463.2 406.7l-8.7-8.7c-2-2-5.1-2-7.1 0s-2 5.1 0 7.1l8.7 8.7c1.9 1.9 1.9 5.1 0 7.1l-33.9 33.9c-.9.9-2.2 1.5-3.5 1.5s-2.6-.5-3.5-1.5l-74-74c-1.9-1.9-1.9-5.1 0-7.1l4.1-4.1c.9-.9 1.5-2.2 1.5-3.5s-.5-2.6-1.5-3.5L315 332.1c3.3-2.8 6.5-5.8 9.6-8.9s6.1-6.3 8.9-9.6l26.7 26.7-2.2 2.2c-2 2-2 5.1 0 7.1s5.1 2 7.1 0l9.9-9.9c.9-.9 2.2-1.5 3.5-1.5s2.6.5 3.5 1.5l45.5 45.5c1 1 2.3 1.5 3.5 1.5s2.6-.5 3.5-1.5c2-2 2-5.1 0-7.1L389 332.6c-2.8-2.8-6.6-4.4-10.6-4.4s-7.8 1.6-10.6 4.4l-.6.6-27.5-27.5c17.5-23.2 28.4-50.4 31.8-79.8 4.1-35.9-3.8-72.7-22.4-103.5 3.1-6.9 5-14.4 5.5-22.3 1.2-19-5.8-37.6-19.2-51-13.4-13.4-32-20.4-51-19.2-15.2 1-29.2 7.3-39.9 17-55.3-12.4-112.1 4-152.2 44.1-27.2 27.5-44.1 63.8-47.3 102.4-3.1 37.4 6.7 74.9 27.7 105.8-3.2 6.6-5 14-5 21.8 0 27.8 22.6 50.3 50.3 50.3 11.9 0 22.8-4.1 31.4-11 19.2 7.4 39.3 11 59.1 11 35.3 0 70-11.4 98.7-32.9l27.5 27.5-.6.6c-5.8 5.8-5.8 15.4 0 21.2l74 74c2.8 2.8 6.6 4.4 10.6 4.4s7.8-1.6 10.6-4.4l33.9-33.9c5.8-5.8 5.8-15.3 0-21.1zM285.2 40c16.1-1 31.9 4.9 43.3 16.3s17.3 27.2 16.3 43.3c-1.8 27.4-23.7 49.8-51 52.1-12.8 1.1-25.2-2.1-35.8-9.1-.8-.6-1.8-.8-2.8-.8-.7 0-1.4.1-2 .4l-19 8.4 8.4-19c.7-1.6.5-3.4-.4-4.8-7-10.6-10.2-23-9.1-35.8 2.3-27.4 24.7-49.3 52.1-51zM168 315.1c-2.9-25-24.2-44.5-50-44.5-1.9 0-3.7.1-5.5.3-30.4-45.5-24.4-106.4 14.5-145.3 25.4-25.4 60.3-37.4 96-32.9-.6 13.2 2.6 26 9.4 37.2l-7.5 17c-1.6 3.7-.8 8 2 10.9 2.9 2.9 7.2 3.7 10.9 2l17-7.5c10.3 6.2 21.9 9.5 34 9.5 1.9 0 3.9-.1 5.8-.2 6.3-.5 12.3-2 18-4.2 9.7 20.4 13.3 43.8 10.1 66.3-3.6 24.8-14.8 47.2-32.6 65-32 32-79.8 42.3-122.1 26.4zm-68.4-217c36.2-36.2 87.1-51.9 137.1-42.6-6.1 7.9-10.5 17.1-12.5 27.2-38.7-4.9-76.6 8.1-104.3 35.7-41.3 41.5-48.5 105.7-17.9 154.9-9.4 3.2-17.6 9-23.6 16.6-38.7-60.7-30.2-140.4 21.2-191.8zM77.7 321c0-22.2 18.1-40.3 40.3-40.3s40.3 18.1 40.3 40.3-18.1 40.3-40.3 40.3-40.3-18.1-40.3-40.3zm79.5 31.5c6-7.5 10-16.7 10.9-26.7 13.2 4.5 26.8 6.7 40.4 6.7 32.7 0 64.7-12.8 88.7-36.7 19.3-19.3 31.5-43.7 35.4-70.6 3.5-24.5-.4-49.9-10.9-72.1 8.8-5.1 16.3-12.1 21.9-20.4 15.4 27.8 21.8 60.3 18.1 92.1-4 34.9-19.3 66.5-44.1 91.3-29.5 29.5-68.9 45.2-109.1 45.2-17.2 0-34.5-2.9-51.3-8.8z",
    fill: "#0046c1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M118 339c-1.3 0-2.6-.5-3.5-1.5l-13.2-13.2c-2-2-1.9-5.1 0-7.1s5.1-2 7.1 0l9.7 9.7 46.7-46.7c2-2 5.1-2 7.1 0s2 5.1 0 7.1l-50.2 50.2c-1.1 1-2.4 1.5-3.7 1.5z",
    fill: "#fff"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "market-analysis_svg__i",
    gradientUnits: "userSpaceOnUse",
    x1: 247.4,
    y1: 293.25,
    x2: 290,
    y2: 293.25,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M282.4 228.9c4.7-3.9 7.6-9.8 7.6-16.3 0-11.8-9.6-21.3-21.3-21.3s-21.3 9.6-21.3 21.3c0 6.5 3 12.4 7.6 16.3-4.7 3.9-7.6 9.8-7.6 16.3 0 2.8 2.2 5 5 5s5-2.2 5-5c0-6.2 5.1-11.3 11.3-11.3S280 239 280 245.2c0 2.8 2.2 5 5 5s5-2.2 5-5c0-6.6-3-12.4-7.6-16.3zm-25-16.4c0-6.2 5.1-11.3 11.3-11.3s11.3 5.1 11.3 11.3-5.1 11.3-11.3 11.3c-6.3.1-11.3-5-11.3-11.3z",
    fill: "url(#market-analysis_svg__i)"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "market-analysis_svg__j",
    gradientUnits: "userSpaceOnUse",
    x1: 133.152,
    y1: 329.45,
    x2: 160.952,
    y2: 329.45,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M149.6 203.7h-5c-6.3 0-11.4-5.1-11.4-11.4v-15.5c0-6.3 5.1-11.4 11.4-11.4h5c6.3 0 11.4 5.1 11.4 11.4v15.5c0 6.3-5.2 11.4-11.4 11.4zm-5-28.2c-.8 0-1.4.6-1.4 1.4v15.5c0 .8.6 1.4 1.4 1.4h5c.8 0 1.4-.6 1.4-1.4v-15.5c0-.8-.6-1.4-1.4-1.4h-5z",
    fill: "url(#market-analysis_svg__j)"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "market-analysis_svg__k",
    gradientUnits: "userSpaceOnUse",
    x1: 166.545,
    y1: 329.45,
    x2: 181.665,
    y2: 329.45,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M176.7 203.7c-2.8 0-5-2.2-5-5v-23.3h-.1c-2.8 0-5-2.2-5-5s2.2-5 5-5h5.1c2.8 0 5 2.2 5 5v28.3c0 2.8-2.3 5-5 5z",
    fill: "url(#market-analysis_svg__k)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketAnalysis);
export default __webpack_public_path__ + "static/media/market-analysis.712a29d3d04df378c50385e07d25792b.svg";
export { ForwardRef as ReactComponent };